import { useUpdateEffect } from '@cian/react-utils';

import { batch } from 'react-redux';

import { boundActionsFactory } from '@/packages/redux-state/store';
import { useFiltersBboxSelector } from '@/packages/redux-state/store/slices/jsonQuery/selectors/dumb';
import { useMapInitializedSelector } from '@/packages/redux-state/store/slices/mapConfiguration/selectors/dumb';
import { useActivePinIdSelector } from '@/packages/redux-state/store/slices/mapControls';
import { scrollToTopWithCallback } from '@/packages/utils';

const useBoundActions = boundActionsFactory(reduxActions => ({
  clearActivePin: reduxActions.mapControls.clearActivePin,
  setPage: reduxActions.jsonQuery.setPageWithUpdateQueryKey,
}));

/**
 * Обновление листинга, когда обновили границы карты
 */
export function useUpdateOnBoundsChange(): void {
  const bounds = useFiltersBboxSelector();

  const activePinId = useActivePinIdSelector();

  const boundActions = useBoundActions();

  const mapInitialized = useMapInitializedSelector();

  useUpdateEffect(() => {
    if (!mapInitialized) {
      return;
    }

    batch(() => {
      if (activePinId) {
        /**
         * Сбрасываем листинг по пину
         */
        boundActions.clearActivePin();
      }

      scrollToTopWithCallback(() => {
        /**
         * Сбрасываем страницу в 1 и обновляем офферы
         */
        boundActions.setPage(1);
      });
    });
  }, [bounds]);
}
